// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// Import New Window Script
import './plugins/jquery.newWin';

// Import Touch Support via jQuery Mobile
import './plugins/jquery.mobile.custom.js';

// Lazysizes
// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks.min';
// import 'lazysizes/lazysizes';

// LazyLoad XT
// import 'lazyloadxt/dist/jquery.lazyloadxt.extra';
// import 'lazyloadxt/dist/jquery.lazyloadxt.srcset';

// Blazy
import 'blazy/blazy';

// Video Sourceset
import './plugins/jquery.video-srcset';

// object-cover polyfill
import 'objectFitPolyfill/dist/objectFitPolyfill.min';

// swiper
import 'swiper/dist/js/swiper';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js